export default {
      id: "change_button_regular_oranje-usage",
      viewBox: "0 0 102.7 36",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#change_button_regular_oranje-usage",
      toString: function () {
        return this.url;
      }
    }